const isConsideredMedium = (state = false, action) => {
  switch (action.type) {
      case 'IS_CONSIDERED_MEDIUM':
          return action.medium
      default:
          return state
  }
}

export default isConsideredMedium;